import type { PanelTrim } from '../panel-trim.class';
import type { PanelTrimType } from '../enums';

// each half is set via the plain trimType setter (never via setTrimTypePaired again), so this can never recurse
export const setTrimTypePairedCfn = (panelTrim: PanelTrim, trimType: PanelTrimType): void => {
	panelTrim.trimType = trimType;

	const paired = panelTrim.pairedSeamTrim;
	if (paired && paired.id !== panelTrim.id) paired.trimType = trimType;
};
